import { jsonArrayMember, jsonMember, jsonObject } from 'typedjson';
import { Nillable } from '@web/utils';
import { AdminBoxSaleGroupRequest } from './admin-box-sale-group.request';

@jsonObject
export class AdminBoxSaleUpdateRequest {
  @jsonMember(Number)
  public readonly validityHours!: number;

  @jsonMember(String)
  public readonly description?: Nillable<string>;

  @jsonArrayMember(AdminBoxSaleGroupRequest)
  public readonly groups!: AdminBoxSaleGroupRequest[];

  public constructor(
    private readonly data: {
      validityHours: number;
      description?: Nillable<string>;
      groups: AdminBoxSaleGroupRequest[];
    },
  ) {
    this.validityHours = this.data.validityHours;
    this.description = this.data.description;
    this.groups = this.data.groups;
  }
}
